
<script>
import New from './New7'
import Edit from '../Edit'
export default {
  mixins: [New, Edit]
}
</script>
